import React, { useState } from "react";
import { toast } from "../hooks/use-toast";
import { ArrowUpRight } from "lucide-react";

const ApplyForSupport = () => {
  const [form, setForm] = useState({ org: '', founded: '', city: '', focus: '', youth: '', need: '', link: '', email: '' });
  const upd = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const submit = (e) => { e.preventDefault(); toast({ title: 'Application received', description: 'We’ll review and be in touch.' }); setForm({ org: '', founded: '', city: '', focus: '', youth: '', need: '', link: '', email: '' }); };
  return (
    <div>
      <section className="max-w-[1100px] mx-auto px-6 lg:px-10 pt-20 pb-10">
        <div className="section-eyebrow text-[#0d2a20]/60 mb-6">Apply for support</div>
        <h1 className="hero-title text-[52px] md:text-[88px] leading-[0.95]">Tell us about your <span className="font-serif-i text-[#e0684d]">work.</span></h1>
        <p className="mt-8 max-w-[720px] text-[17px] leading-relaxed text-[#0d2a20]/80">A short form so we can understand what you&rsquo;re building and how Vemoye can help.</p>
      </section>
      <section className="max-w-[1100px] mx-auto px-6 lg:px-10 pb-24">
        <form onSubmit={submit} className="rounded-lg p-8 md:p-10 space-y-4" style={{ background: '#fbf8ef' }}>
          {[['org','Organisation name *',true],['founded','Year founded *',true],['city','City *',true],['focus','Primary focus (STEM, Leadership, etc.) *',true],['youth','Youth reached to date',false],['link','Website / social link',false],['email','Contact email *',true]].map(([k,l,req]) => (
            <div key={k}>
              <label className="text-[12px] text-[#0d2a20]/70">{l}</label>
              <input required={req} value={form[k]} onChange={e => upd(k, e.target.value)} className="w-full mt-1 px-3 py-2 rounded-md bg-white border" style={{ borderColor: 'rgba(13,42,32,0.15)' }} />
            </div>
          ))}
          <div>
            <label className="text-[12px] text-[#0d2a20]/70">What kind of support do you need? *</label>
            <textarea required rows={5} value={form.need} onChange={e => upd('need', e.target.value)} className="w-full mt-1 px-3 py-2 rounded-md bg-white border" style={{ borderColor: 'rgba(13,42,32,0.15)' }} />
          </div>
          <button className="inline-flex items-center gap-2 px-5 py-3 rounded-md btn-coral text-[14px]">Submit application <ArrowUpRight size={16} /></button>
        </form>
      </section>
    </div>
  );
};

export default ApplyForSupport;
